import { Component } from '@angular/core';
import { FBAbstractControl } from '../abstract.control';

@Component({
  selector: 'fb-controls-progress-bar',
  templateUrl: './progress-bar.component.html',
})
export class FBControlsProgressBarComponent extends FBAbstractControl {
  constructor() {
    super();
  }

  static PROPERTIES() {
    return Object.freeze({
      common: {
        ...FBAbstractControl.DefaultProperties(),
      },
      booleans: {
        ...FBAbstractControl.BooleansProperties(),
      },
    });
  }
}
